import { flatten } from 'lodash';

export const ldJSON = (article, $dateTime, railsHost) => {
  let image = [];
  if (article.images) {
    image = flatten(Object.values(article.images).map(i => [i && i.webp, i && i.fallback])).filter(i => i);
  } else {
    image = [article.image];
  }

  const datePublished = article.published_at ? $dateTime(article.published_at) : null;
  const dateModified = article.updated_at ? $dateTime(article.updated_at) : null;

  const logo = { '@type': 'ImageObject',
                 url: 'https://www.bonkers.ie/bonkers-logo.svg',
                 width: 227,
                 height: 60 };
  const result = { '@context': 'http://schema.org',
                   '@type': 'NewsArticle',
                   mainEntityOfPage: {
                     '@type': 'WebPage',
                     '@id': `${railsHost}${article.path}`
                   },
                   headline: `${article.headline} | bonkers.ie`,
                   image,
                   datePublished,
                   dateModified,
                   author: article.author ? { '@type': 'Person', 'name': article.author.fullname } : null,
                   publisher: { '@type': 'Organization', name: 'bonkers.ie', logo },
                   description: article.summary
                 };

  return JSON.stringify(result);
};
